
/* rbTranslater
 * add auto translator based on google translation
 */


function createCookie ( propName, value ) {
    var domain = window.location.hostname.split( '.' );
    for (; 2 < domain.length;) {
        domain.shift();
    }
    domain = ';domain=' + domain.join( '.' );

    propName = propName + '=' + value;
    propName += ';path=/';

    document.cookie = propName;
    try {
        document.cookie = propName + domain;
    } catch (error) {
    }
}

angular.module( 'ribytRsvpApp' )
    .directive( 'rbTranslater', [ '$cookies', 'lodash',  function ( $cookies, _ ) {
            return {
                'restrict': 'A',
                'replace': true,
                'templateUrl': 'scripts/directives/rbTranslater/rbTranslater.html',
                'link': function ( scope ) {
                    setTimeout( function () {
                        // remove style what added by google script
                        angular.element( 'body' ).attr( 'style', '' );
                    }, 1500 );

                    var languages = [
                        { label: 'English', code: '/en' },
                        { label: 'German', code: '/en/de' },
                        { label: 'Spanish', code: '/en/es' },
                        { label: 'French', code: '/en/fr' },
                        { label: 'Italian', code: '/en/it' },
                        { label: 'Russian', code: '/en/ru' },
                        { label: 'Japanese', code: '/en/ja' },
                        { label: 'Chinese', code: '/en/zh-TW' }
                    ];

                    scope.languages = languages.filter( function ( lang ) {
                        return lang.code !== $cookies.get( 'googtrans' );
                    } );

                    scope.defaultLang = _.chain( languages )
                        .filter( {code: $cookies.get( 'googtrans' )} )
                        .get( '[0].label', 'English' )
                        .value();

                    scope.selectLang = function ( lang ) {
                        createCookie( 'googtrans', lang.code );
                        window.location.reload();
                    };
                }
            };
        }
    ] );
